<template>
  <v-autocomplete
    hide-details="auto"
    :items="ledger"
    :loading="loadingLedger"
    v-model="selectLedger"
    item-text="name"
    item-value="id"
    label="Ledger Type"
    outlined
    dense
    clearable
    multiple
    @change="emitInput"
    :search-input.sync="searchLedger"
  ></v-autocomplete>
</template>
<script>
import axios from '@/plugins/axios';
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    ledger: [],
    selectLedger: null,
    searchLedger: null,
    loadingLedger: false,
  }),
  methods: {
    emitInput() {
      this.$emit('input', this.selectLedger);
    },
    getLedgerByQuery(payload = '') {
      this.projectsLoading = true;
      let url = 'ledger-types/search?';
      if (payload != null && payload != undefined) {
        if (payload.query != '' && payload.query != null) {
          url += `query=${payload.query}&`;
        }
        if (payload.status != '' && payload.status != null) {
          url += `status=${payload.status}`;
        }
        if (
          payload.except != undefined &&
          payload.except != null &&
          payload.except.length > 0
        ) {
          url += `except=[${payload.except}]`;
        }
      }
      axios
        .get(url)
        .then((resp) => {
          this.ledger = resp.data.data;
          this.loadingLedger = false;
        })
        .catch((err) => {
          this.loadingLedger = false;
          this.messages = err.data.title;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectLedger = null;
      },
      deep: true,
    },
    searchLedger: {
      handler(val) {
        this.getLedgerByQuery(val);
      },
      deep: true,
    },
  },
  created() {
    this.getLedgerByQuery();
  },
};
</script>
